import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the advertising table view.
 * @extends JetView
 */
export default class tableAdvertisingView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            view: 'datatable', // Main view type
            css: 'webix_header_border webix_data_border', // CSS classes for styling
            id: 'datatable3', // Unique identifier for the datatable
            select: true, // Enable row selection
            minHeight: 300, // Minimum height of the datatable
            columns: [
                // Column definitions
                {
                    id: 'rating', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Row height
                    tooltip: _('Editar'), // Tooltip text for the column
                    hidden: false && !devConfig.getPermAction('permAdvertising', 'Edit'), // Conditional visibility based on permissions
                    css: 'prm-permAdvertising', // CSS class for styling
                    template: function (obj) {
                        // Template function for rendering cell content
                        return "<span class='webix_icon wxi-close edit'></span>"; // Icon for editing
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Name', header: _('Nombre'), width: 300, sort: 'int' }, // Name column
                { id: 'Route', header: _('Ruta'), width: 350, sort: 'int' }, // Route column
                {
                    id: 'IsActivate', // Activation status column
                    header: _('Estado'), // Column header
                    editor: 'combo', // Editor type for the column
                    options: [
                        // Options for the combo editor
                        { id: 'A', value: _('Activado') }, // Activated option
                        { id: 'I', value: _('Inactivado') }, // Inactivated option
                    ],
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Order', header: _('Orden'), width: 270, sort: 'int' }, // Order column
            ],
            onClick: {
                // Event handler for click events
                edit: function (euv, id) {
                    // Function to handle edit icon clicks
                    $$('editwinAdvertising').show(); // Show the edit window
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID for pagination
            // Data source URL for the datatable
            url: devConfig.geturlApi() + 'es/Machine/GetAdvertising?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        const cur_user = this.getParam('user', true); // Current user parameter

        // Event handler for sorting the datatable
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir);
        });

        // Event handler for item clicks in the datatable
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for adding advertising
        this.on(this.app, 'addAdvertising:button', (filter) => {
            popupAdd.show(); // Show the add advertising popup
        });

        // Popup for adding new advertising
        var popupAdd = webix.ui({
            view: 'window', // Window view type
            id: 'addwin', // Unique identifier for the window
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Publicidad') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Make the window modal
            width: 5000, // Window width
            body: {
                // Body configuration
                view: 'form', // Form view type
                id: 'saveformAdv', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        view: 'text', // Text input for Name
                        name: 'Name',
                        label: _('Nombre'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Route
                        name: 'Route',
                        label: _('Ruta'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'combo', // Combo input for IsActivate
                        label: _('Estado'), // Label for the input
                        name: 'IsActivate',
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        options: [
                            // Options for the combo
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Inactivated option
                        ],
                    },
                    {
                        view: 'text', // Text input for Order
                        value: '0', // Default value
                        name: 'Order',
                        label: _('Orden'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                        type: 'number', // Input type
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on click
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('saveformAdv').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save advertising
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Machine/SaveAdvertising',
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _('Publicidad Añadida'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(url); // Reload the grid data
                                                },
                                            },
                                        );
                                    $$('saveformAdv').clear(); // Clear the form
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Popup for editing existing advertising
        var popupEdit = webix.ui({
            view: 'window', // Window view type
            id: 'editwinAdvertising', // Unique identifier for the window
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Publicidad') }, // Label for the window
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Make the window modal
            width: 5000, // Window width
            body: {
                // Body configuration
                view: 'form', // Form view type
                id: 'editformAdv', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        view: 'text', // Text input for ID
                        name: 'Id',
                        label: 'ID', // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        disabled: true, // Disable input
                    },
                    {
                        view: 'text', // Text input for Name
                        name: 'Name',
                        label: _('Nombre'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text', // Text input for Route
                        name: 'Route',
                        label: _('Ruta'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'combo', // Combo input for IsActivate
                        label: _('Estado'), // Label for the input
                        name: 'IsActivate',
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        options: [
                            // Options for the combo
                            { id: 'A', value: _('Activado') }, // Activated option
                            { id: 'I', value: _('Inactivado') }, // Inactivated option
                        ],
                    },
                    {
                        view: 'text', // Text input for Order
                        name: 'Order',
                        label: _('Orden'), // Label for the input
                        labelWidth: 150, // Label width
                        width: 300, // Input width
                        sort: 'int', // Sorting type
                        type: 'number', // Input type
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on click
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editformAdv').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save advertising
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/Machine/SaveAdvertising',
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Id":"' +
                                                values.Id +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        _(
                                                            'Publicidad Actualizada', // Show success message
                                                        ),
                                                    );
                                                    grid.clearAll(); // Clear the grid
                                                    grid.load(url); // Reload the grid data
                                                },
                                            },
                                        );
                                    $$('saveformAdv').clear(); // Clear the form
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id, // Load data based on selected player ID
            );
        });

        // Event handler for double-clicking items in the datatable
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            if (devConfig.getPermAction('permAdvertising', 'Edit')) {
                // Check edit permissions
                popupEdit.show(); // Show the edit popup
            }
        });

        $$('editformAdv').bind($$('datatable3')); // Bind the edit form to the datatable
    }
}

// FILE DOCUMENTED
